.faq-page {
  background-color: #0B1120;
  color: #F1F5F9;
  min-height: 100vh;
  font-family: var(--font-family);
}

.faq-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
}

/* Header */
.faq-header {
  padding: 24px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}
.faq-header .faq-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.faq-logo {
  display: flex;
  align-items: center;
  gap: 12px;
  color: #fff;
  text-decoration: none;
  font-weight: 700;
  font-size: 24px;
  font-family: var(--font-heading);
  letter-spacing: -0.5px;
}
.faq-logo svg {
  width: 28px;
  height: 28px;
  color: var(--color-primary);
}
.faq-header-links {
  display: flex;
  align-items: center;
  gap: 24px;
}
.faq-nav-link {
  color: #CBD5E1;
  text-decoration: none;
  font-size: 15px;
  font-weight: 500;
  transition: color 0.2s;
}
.faq-nav-link:hover {
  color: #fff;
}
.faq-btn-primary {
  background: var(--color-primary);
  color: #fff;
  padding: 10px 20px;
  border-radius: 8px;
  text-decoration: none;
  font-weight: 600;
  font-size: 14px;
  transition: background 0.2s;
}
.faq-btn-primary:hover {
  background: var(--color-primary-dark);
}

/* Hero Section */
.faq-hero {
  padding: 140px 0 60px;
  text-align: center;
  background: radial-gradient(circle at center, rgba(99,91,255,0.1) 0%, transparent 60%);
}
.faq-section-label {
  display: inline-block;
  padding: 6px 14px;
  background: rgba(99,91,255,0.15);
  color: #A5B4FC;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 1px;
  text-transform: uppercase;
  margin-bottom: 24px;
}
.faq-hero-title {
  font-family: var(--font-heading);
  font-size: 56px;
  font-weight: 800;
  color: #fff;
  margin-bottom: 24px;
  line-height: 1.1;
  letter-spacing: -1px;
}
.faq-hero-subtitle {
  font-size: 18px;
  color: rgba(255, 255, 255, 0.6);
  max-width: 600px;
  margin: 0 auto;
  line-height: 1.6;
}

/* Content */
.faq-content {
  padding: 40px 0 120px;
}
.faq-content-container {
  max-width: 800px;
}
.faq-category-block {
  margin-bottom: 64px;
}
.faq-category-title {
  font-family: var(--font-heading);
  font-size: 24px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 24px;
  padding-bottom: 12px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}
.faq-accordion {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.faq-accordion-item {
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.3s ease;
}
.faq-accordion-item.open {
  background: rgba(255, 255, 255, 0.06);
  border-color: rgba(99,91,255,0.3);
}
.faq-accordion-trigger {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px;
  background: transparent;
  border: none;
  color: #fff;
  cursor: pointer;
  text-align: left;
}
.faq-question {
  font-size: 17px;
  font-weight: 600;
  line-height: 1.4;
}
.faq-icon {
  width: 20px;
  height: 20px;
  color: rgba(255, 255, 255, 0.5);
  transition: transform 0.3s ease, color 0.3s ease;
  flex-shrink: 0;
}
.faq-accordion-item.open .faq-icon {
  transform: rotate(180deg);
  color: var(--color-primary);
}
.faq-accordion-content {
  overflow: hidden;
  max-height: 0;
  transition: max-height 0.3s ease-in-out;
}
.faq-answer {
  padding: 0 24px 24px;
  color: rgba(255, 255, 255, 0.65);
  font-size: 15px;
  line-height: 1.7;
  margin: 0;
}
.faq-article-link {
  padding: 0 24px 24px;
  margin-top: -8px;
}
.faq-article-link a {
  color: var(--color-accent-light, #A5B4FC);
  text-decoration: none;
  font-size: 14px;
  font-weight: 600;
  transition: color 0.2s, letter-spacing 0.2s;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
.faq-article-link a:hover {
  color: #fff;
  letter-spacing: 0.3px;
}

/* CTA Box */
.faq-cta-box {
  background: linear-gradient(135deg, rgba(99,91,255,0.15) 0%, rgba(99,91,255,0.05) 100%);
  border: 1px solid rgba(99,91,255,0.2);
  border-radius: 16px;
  padding: 48px;
  text-align: center;
  margin-top: 80px;
}
.faq-cta-box h3 {
  font-family: var(--font-heading);
  font-size: 28px;
  color: #fff;
  margin-bottom: 16px;
}
.faq-cta-box p {
  color: rgba(255, 255, 255, 0.7);
  font-size: 16px;
  margin-bottom: 32px;
}
.faq-btn-secondary {
  display: inline-block;
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
  padding: 12px 28px;
  border-radius: 8px;
  text-decoration: none;
  font-weight: 600;
  font-size: 15px;
  transition: background 0.2s;
  border: 1px solid rgba(255, 255, 255, 0.1);
}
.faq-btn-secondary:hover {
  background: rgba(255, 255, 255, 0.15);
}

/* Footer */
.faq-footer {
  border-top: 1px solid rgba(255, 255, 255, 0.05);
  padding: 60px 0 30px;
  background: #0f172a;
}
.faq-footer-content {
  display: flex;
  justify-content: space-between;
  margin-bottom: 60px;
  flex-wrap: wrap;
  gap: 48px;
}
.faq-footer-brand {
  max-width: 320px;
}
.faq-footer-brand p {
  color: rgba(255, 255, 255, 0.5);
  font-size: 14px;
  line-height: 1.6;
  margin-top: 20px;
}
.faq-footer-links {
  display: flex;
  gap: 80px;
}
.faq-footer-col h4 {
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 24px;
}
.faq-footer-col a {
  display: block;
  color: rgba(255, 255, 255, 0.5);
  text-decoration: none;
  font-size: 14px;
  margin-bottom: 12px;
  transition: color 0.2s;
}
.faq-footer-col a:hover {
  color: #fff;
}
.faq-footer-bottom {
  text-align: center;
  padding-top: 30px;
  border-top: 1px solid rgba(255, 255, 255, 0.05);
  color: rgba(255, 255, 255, 0.4);
  font-size: 13px;

.faq-accordion-item.open .faq-accordion-content {
  max-height: 1000px;
}